// extracted by mini-css-extract-plugin
var _1 = "AccountDetailsPage_container__Mk30a";
var _2 = "AccountDetailsPage_header__NLaEl";
var _3 = "992px";
var _4 = "768px";
var _5 = "AccountDetailsPage_sectionContainer__jE0En";
var _6 = "AccountDetailsPage_sectionContainerTitle__AJAhW";
var _7 = "\"../shared.module.css\"";
var _8 = "AccountDetailsPage_tooltip__qzlCa";
export { _1 as "container", _2 as "header", _3 as "lg", _4 as "md", _5 as "sectionContainer", _6 as "sectionContainerTitle", _7 as "shared", _8 as "tooltip" }
